/** @see https://babeljs.io/docs/en/babel-plugin-syntax-dynamic-import#working-with-webpack-and-babelpreset-env */

if (process.env.NODE_ENV === 'production') {
  global.window = {}; // Temporarily define window for server-side
}
